import { Affix, Button, Card } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import HourlyOperationTracking from "./HourlyOperationTrackingForm";

const AddHourlyOperationTracking = (props) => {
  // Props
  const { width } = props;

  // States
  const [poDetailsData, setPoDetailsData] = useState([]);

  // Others
  const propertyFormRef = useRef(null);
  const navigate = useNavigate();

  const discartForm = () => {
    navigate("/digitalization/hourly-operation-tracking");
  };

  const addPurchaseOrder = () => {
    propertyFormRef.current.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Hourly Operation Tracking"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={() => addPurchaseOrder()}>
                Add Hourly Operation Tracking
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <HourlyOperationTracking
        ref={propertyFormRef}
        poDetailsData={poDetailsData}
        setPoDetailsData={setPoDetailsData}
        mode={"add"}
      />
    </>
  );
};

export default AddHourlyOperationTracking;
